// Handle redirect when visit /c/#code
function init() {
  const { pathname = '/', searchParams, hash } = new URL(window.location.href);
  const parts = pathname.split('/');
  if (parts.length > 2 && parts[1] === 'c') {
    searchParams.append('ref', parts[2]);
    window.location.href = `${process.env.APP_BASE_URL}/sign-up?${searchParams.toString()}${hash}`;
  }
}

(() => {
  init();
})();
